module.exports = __webpack_public_path__ + "cccc9d29470e879e40eb70249d9a2705.woff2";